import HeroSectionWithButton from "../SkillAnalytics/Components/HeroSectionWithButton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ShowcaseSection from "../SkillAnalytics/Components/ShowcaseSection";
import ImageAndTextSectionWithBullets from "../SkillManagement/Components/ImageTextSectionWithBullets";
import { useTranslation } from "react-i18next";

const IndividualServices = () => {
  const { t } = useTranslation();

  const showcaseList = [
    {
      icon: "product-personality-inventory",
      text: t("landing.individualServices.showcase.personalityInventories"),
    },
    {
      icon: "product-capability-inventory",
      text: t("landing.individualServices.showcase.competencyInventories"),
    },
    {
      icon: "product-general-skill-test",
      text: t("landing.individualServices.showcase.generalAbilityTests"),
    },
    {
      icon: "product-language-test",
      text: t("landing.individualServices.showcase.languageTests"),
    },
    {
      icon: "services-mentorship",
      text: t("landing.individualServices.showcase.careerConsulting"),
    },
    {
      icon: "services-improvement-center",
      text: t("landing.individualServices.showcase.developmentCenter"),
    },
  ];
  return (
    <div className={"p-0"}>
      <HeroSectionWithButton
        imageSrc={"/LandingPageImages/office.webp"}
        isImageOnRight={true}
        headerText={t("landing.individualServices.section1.header")}
        subHeader={t("landing.individualServices.section1.subheader")}
        isButtonHidden={true}
      >
        {t("landing.individualServices.section1.content")}
      </HeroSectionWithButton>

      <HeroSectionWithButton
        subHeader={t("landing.individualServices.section2.subheader")}
        isButtonHidden={true}
        isImageHidden={true}
      >
        {t("landing.individualServices.section2.content")}
      </HeroSectionWithButton>

      <HeroSectionWithButton
        subHeader={t("landing.individualServices.section3.subheader")}
        isButtonHidden={true}
        isImageHidden={true}
      ></HeroSectionWithButton>

      <ShowcaseSection showcaseList={showcaseList}></ShowcaseSection>

      {/*<ImageAndTextSectionWithBullets
        imageSrc={"/LandingPageImages/officeV2.webp"}
        header={"Kişilik Envanterleri"}
        bullets={[
          "Yetenek Yönetimi Eğitimi",
          '"Hiring Manager" Eğitimi ',
          "Yetkinlik Bazlı Mülakat Teknikleri Eğitimi",
          "Değerlendirme Merkezi & Assessor Eğitimi",
          "Ölçme-Değerlendirme Eğitimleri",
          "Psikometrik Test & Envanter Eğitimleri ",
          "Yetenek Gelişim Programları",
        ]}
      ></ImageAndTextSectionWithBullets>*/}
    </div>
  );
};
export default IndividualServices;
